module.exports = __webpack_public_path__ + "static/media/6.115959f9.jpg";